import Vue from 'vue'
import appService from '../../server/app.service'
import _ from 'lodash'
import router from '../../router'

const state = {
    languages: [],
    language: {},
    id: 0
}

const getters = {
    languages: state => state.languages,
    language: state => state.language,
}

const actions = {

    loadLanguages (context, credentials) {
        appService.connectToServer(credentials).then(data => {
            context.commit('loadLanguages', { languages: data })
        }).catch(error => {
            context.dispatch('addMessage', { message: error.toString() }, { root: true })
        })
    },

    loadLanguage (context, credentials) {
        return appService.connectToServer(credentials).then(data => {
            context.commit('loadLanguage', { language: data })
        }).catch(error => {
            context.dispatch('addMessage', { message: error.toString() }, { root: true })
        })
    },

    async saveLanguage(context, credentials) {
        try {
            const data = await appService.connectToServer(credentials);
            if (data.success) {
                context.commit('saveLanguage', {
                    Language: data.Language,
                });
                context.dispatch('addMessage', data, { root: true });
                return data.Language;
            }
            context.dispatch('addMessage', data, { root: true });
        } catch (err) {
            context.dispatch('addMessage', { message: err.toString() }, { root: true });
        }
    },

    deleteLanguage (context, credentials) {
        appService.connectToServer(credentials).then(data => {
            if( data.success ) {
                context.commit('deleteLanguage', { success: data.success, id: data.id  })
                context.dispatch('addMessage', data, { root: true })
            } else {
                context.dispatch('addMessage', data, { root: true })
            }
        }).catch(error => {
            context.dispatch('addMessage', { message: error.toString() }, { root: true })
        })
    },

    resetLanguage (context) {
        context.commit('resetLanguage')
    },

}

const mutations = {

    loadLanguages (state, data) {
        state.languages = data.languages.result
    },
    loadLanguage (state, data) {
        state.language = data.language.result
    },
    deleteLanguage (state, data) {
        let index = _.findIndex(state.languages, function(o) { return o.id == data.id; });
        state.languages.splice(index, 1)
    },
    saveLanguage(state, { Language }) {
        state.language.requestLogCreate = Language.requestLogCreate;
        state.language.requestLogUpade = Language.requestLogUpade;
        if (Language.language !== undefined) state.language.language = Language.language;
        if (Language.slug     !== undefined) state.language.slug     = Language.slug;
        if (Language.code     !== undefined) state.language.code     = Language.code;
    },
    resetLanguage(state) {
        state.language = {}
    },

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
